export const validateFileExtension = (file, allowedExtensions) => {
  const fileExtension = file.name
    .substring(file.name.lastIndexOf("."))
    .toLowerCase();
  const isValidExtension = allowedExtensions.some(
    (ext) => ext.toLowerCase() === fileExtension
  );

  if (!isValidExtension) {
    return {
      isValid: false,
      error: `Please upload a file with one of these extensions: ${allowedExtensions.join(
        ", "
      )}`,
    };
  }

  return { isValid: true };
};

export const validateExcelFile = (file) =>
  validateFileExtension(file, [".xlsx", ".xls"]);

export const validateZipFile = (file) => validateFileExtension(file, [".zip"]);
